import { render, staticRenderFns } from "./ContentTypeLabel.vue?vue&type=template&id=1bcbe6ac"
import script from "./ContentTypeLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentTypeLabel.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports